/**
 * @generated SignedSource<<bc5b51718992ceb32a6b2871bad9a2fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SortDirection = "ASC" | "DESC";
export type RoomSorting = {
  capacity?: SortDirection | null;
  name?: SortDirection | null;
};
export type HotelEditPageQuery$variables = {
  after?: string | null;
  first: number;
  id: string;
  search?: string | null;
  sort?: RoomSorting | null;
};
export type HotelEditPageQuery$data = {
  readonly hotel: {
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"HotelEditTabs_hotel" | "HotelSidebar_hotel">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"HotelEditTabs_data">;
};
export type HotelEditPageQuery = {
  response: HotelEditPageQuery$data;
  variables: HotelEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locale",
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TextBlockConnection",
    "kind": "LinkedField",
    "name": "blocks",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TextBlockEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TextBlock",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "data",
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v9/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v15 = [
  (v6/*: any*/),
  (v9/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "HotelEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Hotel",
        "kind": "LinkedField",
        "name": "hotel",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HotelEditTabs_hotel"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HotelSidebar_hotel"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "HotelEditTabs_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "HotelEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Hotel",
        "kind": "LinkedField",
        "name": "hotel",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "MediaConnection",
            "kind": "LinkedField",
            "name": "media",
            "plural": false,
            "selections": [
              (v8/*: any*/)
            ],
            "storageKey": "media(first:2147483647)"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "after"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              },
              {
                "kind": "Variable",
                "name": "search",
                "variableName": "search"
              },
              {
                "kind": "Variable",
                "name": "sort",
                "variableName": "sort"
              }
            ],
            "concreteType": "RoomConnection",
            "kind": "LinkedField",
            "name": "rooms",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoomEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Room",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "nameString",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "capacity",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stars",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "features",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reviews",
            "storageKey": null
          },
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aboutLocation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "source",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userEdited",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "City",
            "kind": "LinkedField",
            "name": "city",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Location",
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lat",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lng",
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Text",
            "kind": "LinkedField",
            "name": "descriptionText",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Text",
            "kind": "LinkedField",
            "name": "aboutLocationText",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalId",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "MediaConnection",
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Media",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "S120X120"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "externalUrl",
                            "storageKey": "externalUrl(size:\"S120X120\")"
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "w262"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "src",
                            "storageKey": "src(size:\"w262\")"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "media(first:2147483647)"
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "MediaEditor_mediable_media",
                "kind": "LinkedHandle",
                "name": "media"
              }
            ],
            "type": "Mediable",
            "abstractKey": "__isMediable"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LogEntry",
                "kind": "LinkedField",
                "name": "logs",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v6/*: any*/),
                  (v14/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v15/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "context",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "severity",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Logable",
            "abstractKey": "__isLogable"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "City",
        "kind": "LinkedField",
        "name": "cities",
        "plural": true,
        "selections": [
          (v9/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Region",
            "kind": "LinkedField",
            "name": "region",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Country",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": (v15/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Language",
        "kind": "LinkedField",
        "name": "languages",
        "plural": true,
        "selections": [
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "readOnly",
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5c4367d083abed6df44041159315d868",
    "id": null,
    "metadata": {},
    "name": "HotelEditPageQuery",
    "operationKind": "query",
    "text": "query HotelEditPageQuery(\n  $id: ID!\n  $first: Int!\n  $after: String\n  $search: String\n  $sort: RoomSorting\n) {\n  hotel(id: $id) {\n    name\n    ...HotelEditTabs_hotel\n    ...HotelSidebar_hotel\n    id\n  }\n  ...HotelEditTabs_data\n}\n\nfragment AddRoomDialog_hotel on Hotel {\n  id\n}\n\nfragment CitySelect_data on Query {\n  cities {\n    id\n    name\n    region {\n      id\n      name\n      country {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment EditorJsField_data on Query {\n  languages {\n    locale\n    ...EditorLanguageField_language\n    ...EditorToolbar_languages\n  }\n}\n\nfragment EditorJsField_text on Text {\n  id\n  blocks {\n    edges {\n      node {\n        locale\n        data\n        id\n      }\n    }\n  }\n  ...EditorToolbar_text\n}\n\nfragment EditorLanguageButton_language on Language {\n  name\n  locale\n  ...LanguageIndicator_language\n}\n\nfragment EditorLanguageButton_text on Text {\n  blocks {\n    edges {\n      node {\n        locale\n        data\n        id\n      }\n    }\n  }\n}\n\nfragment EditorLanguageField_language on Language {\n  locale\n  readOnly\n}\n\nfragment EditorToolbar_languages on Language {\n  locale\n  ...EditorLanguageButton_language\n  ...EditorTranslateButton_to\n  ...EditorTranslateButton_from\n}\n\nfragment EditorToolbar_text on Text {\n  blocks {\n    edges {\n      node {\n        locale\n        data\n        ...EditorTranslateButton_textBlock\n        id\n      }\n    }\n  }\n  ...EditorLanguageButton_text\n}\n\nfragment EditorTranslateButton_from on Language {\n  locale\n}\n\nfragment EditorTranslateButton_textBlock on TextBlock {\n  id\n  data\n}\n\nfragment EditorTranslateButton_to on Language {\n  locale\n  readOnly\n}\n\nfragment EntityHistoryEntryIcon_entry on LogEntry {\n  severity\n}\n\nfragment EntityHistoryEntry_entry on LogEntry {\n  name\n  createdAt\n  description\n  user {\n    name\n    id\n  }\n  ...EntityHistoryJsonContext_entry\n  ...EntityHistoryEntryIcon_entry\n}\n\nfragment EntityHistoryJsonContext_entry on LogEntry {\n  context\n}\n\nfragment EntityHistory_entity on Logable {\n  __isLogable: __typename\n  logs {\n    id\n    ...EntityHistoryEntry_entry\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment HotelEditMainGeneral_data on Query {\n  ...CitySelect_data\n}\n\nfragment HotelEditMainGeneral_hotel on Hotel {\n  source\n  externalId\n}\n\nfragment HotelEditMain_data on Query {\n  ...HotelEditMainGeneral_data\n  ...EditorJsField_data\n  ...useEditorJsField_data\n}\n\nfragment HotelEditMain_hotel on Hotel {\n  id\n  name\n  stars\n  features\n  reviews\n  description\n  aboutLocation\n  source\n  userEdited\n  city {\n    id\n    name\n  }\n  location {\n    lat\n    lng\n    id\n  }\n  descriptionText {\n    ...useEditorJsField_text\n    ...EditorJsField_text\n    id\n  }\n  aboutLocationText {\n    ...useEditorJsField_text\n    ...EditorJsField_text\n    id\n  }\n  ...HotelEditMainGeneral_hotel\n}\n\nfragment HotelEditRoomsRow_room on Room {\n  id\n  nameString\n  capacity\n}\n\nfragment HotelEditRooms_hotel on Hotel {\n  id\n  rooms(first: $first, after: $after, search: $search, sort: $sort) {\n    edges {\n      node {\n        id\n        ...HotelEditRoomsRow_room\n      }\n    }\n    pageInfo {\n      ...Table_pageInfo\n    }\n  }\n  ...AddRoomDialog_hotel\n}\n\nfragment HotelEditTabs_data on Query {\n  ...HotelEditMain_data\n}\n\nfragment HotelEditTabs_hotel on Hotel {\n  media(first: 2147483647) {\n    pageInfo {\n      total\n    }\n  }\n  rooms(first: $first, after: $after, search: $search, sort: $sort) {\n    pageInfo {\n      total\n    }\n  }\n  ...HotelEditMain_hotel\n  ...MediaEditor_mediable\n  ...EntityHistory_entity\n  ...HotelEditRooms_hotel\n}\n\nfragment HotelSidebar_hotel on Hotel {\n  source\n  ...EntitySidebar_entity\n}\n\nfragment LanguageIndicator_language on Language {\n  locale\n}\n\nfragment MediaEditorPreviews_media on MediaConnection {\n  edges {\n    node {\n      id\n      ...MediaEditorThumb_media\n    }\n  }\n}\n\nfragment MediaEditorSort_media on MediaConnection {\n  edges {\n    node {\n      id\n    }\n  }\n}\n\nfragment MediaEditorThumb_media on Media {\n  id\n  ...MediaThumb_media\n}\n\nfragment MediaEditor_mediable on Mediable {\n  __isMediable: __typename\n  id\n  media(first: 2147483647) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    ...MediaEditorPreviews_media\n    ...MediaEditorSort_media\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MediaThumb_media on Media {\n  type\n  externalUrl(size: S120X120)\n  src(size: w262)\n}\n\nfragment TablePagination_pageInfo on PageInfo {\n  total\n}\n\nfragment Table_pageInfo on PageInfo {\n  total\n  ...TablePagination_pageInfo\n}\n\nfragment useEditorJsField_data on Query {\n  languages {\n    locale\n  }\n}\n\nfragment useEditorJsField_text on Text {\n  blocks {\n    edges {\n      node {\n        locale\n        data\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "93dccbc7f63359d8843471de68f06d82";

export default node;
